import React, { Component } from 'react';
import c3 from 'c3';
import * as d3 from 'd3';
import 'c3/c3.css';
import './chart.css';
import { isEmpty } from '../Common/Common';
import { Colours } from '../Common/colours.js';

export default class Chart_Bar_Data_Analysis extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}

		this.chart = null;
	}

	componentDidMount() {
		this.generateChart();
		window.addEventListener('resize', this.generateChart);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.generateChart);
	}

	generateChart = () => {
		let width = this.props.chart_width;
		let height = this.props.chart_height;

		let colors = {};
		if (!isEmpty(this.props.colors)) colors = this.props.colors;

		let chartCategory = this.props.data[0];
		let chartCatDevName = [];

		for (let pid of chartCategory) {
			if (!isEmpty(window.app.state.point_list[pid])) {
				chartCatDevName.push(window.app.state.point_list[pid].name);
			} else {
				chartCatDevName.push(pid);
			}
		}

		let chartData = [this.props.data[1], this.props.data[2], this.props.data[3]];

		this.chart = c3.generate({
			bindto: "#chart_" + this.props.id,
			size: {
				width: width,
				height: height,
			},
			data: {
				columns: chartData,
				type: 'bar',
				groups: [[this.props.receiver.getString('cool'), this.props.receiver.getString('heat'), this.props.receiver.getString('standby')]],
			},
			bar: {
				width: {
					ratio: 0.8
				}
			},
			axis: {
				rotated: true,
				x: {
					type: 'category',
					categories: chartCatDevName,
					tick: {
						multiline: false
					}
				},
				y: {
					tick: {
						rotate: 45
					}
				}
			},
			title: {
				text: this.props.title,
				position: 'top-center',   // top-left, top-center and top-right
			},
			color: {
				pattern: [Colours.appBlue, Colours.appRed, Colours.emerald]
			}
		})

		d3.selectAll('.tick').on('click', function (value, index) {
			this.props.handleIDUHourlyChart(chartCategory[index]);
		}.bind(this));

		return this.chart;
	}

	render() {
		let style = {};
		style = Object.assign(style, this.props.style);

		return (
			<div id={"chart_" + this.props.id} style={style} />
		);
	}
}